import { render, staticRenderFns } from "./ManageDashboard.vue?vue&type=template&id=6455b80b&"
import script from "./ManageDashboard.vue?vue&type=script&lang=js&"
export * from "./ManageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManageDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports